import { reaction, runInAction } from 'mobx';
import StorageUtil from '../utils/StorageUtils';
import RootStore from './RootStore';
import UsuarioStore from './UsuarioStore';

export default class Store {
  rootStore: RootStore;

  constructor(rootStore?) {
    this.rootStore = rootStore;

    if (this.objetoSave && this.rootStore) {
      reaction(() => this.objetoSave, (objeto) => {
        this.save(JSON.stringify(objeto));
      });
    }
  }

  // Propriedade sobrescrita pelas stores filhas
  get objetoSave() {
    return {};
  }

  get nomeStorage() {
    return (this.objetoSave as any).nomeStore;
  }

  save = (json: string) => {
    const usuarioStore = UsuarioStore;
    if (this.objetoSave && usuarioStore?.isUsuarioLogado) {
      StorageUtil.setItem(this.nomeStorage, json);
    }
  };

  delete() {
    StorageUtil.removeItem(this.nomeStorage);
  }

  setTimeout(funcao) {
    return setTimeout(runInAction(funcao), 1);
  }

  public inicializar() {
    const usuarioStore = UsuarioStore;
    if (this.objetoSave && usuarioStore?.isUsuarioLogado) {
      const storage = StorageUtil.getObject(this.nomeStorage);
      if (storage) {
        for (const key in this.objetoSave) {
          if (Object.prototype.hasOwnProperty.call(storage, key)) {
            this[key] = storage[key];
          }
        }
      }
    }
  }

  cancelarRequisicoesPendentes() {
    (this.rootStore as any)?.appStore?.zerarRequisicoes?.();
  }
}